// components/LocationModal.jsx
import React, { useEffect, useRef } from 'react';
import { FaLocationArrow } from "react-icons/fa";


function LocationModal({ lat, lng }) {
    const mapRef = useRef(null);

    useEffect(() => {
        if (!lat || !lng) return;
        if (!document.getElementById('leaflet-css')) {
            const link = document.createElement('link');
            link.id = 'leaflet-css';
            link.rel = 'stylesheet';
            link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
            document.head.appendChild(link);
        }

        if (typeof window.L === 'undefined') {
            const script = document.createElement('script');
            script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
            script.onload = () => initMap();
            document.head.appendChild(script);
        } else {
            initMap();
        }

        function initMap() {
            mapRef.current.innerHTML = '';

            const map = window.L.map(mapRef.current).setView([lat, lng], 15);

            window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);

            window.L.marker([lat, lng]).addTo(map)
                .bindPopup('Delivery location')
                .openPopup();
        }
    }, [lat, lng]);

    return (
        <>
            <label htmlFor="location-modal" id="location-open-btn" className="hidden">
                Open Location
            </label>
            <input type="checkbox" id="location-modal" className="modal-toggle" />

            <div className="modal">
                <div className="modal-box w-11/12 max-w-4xl h-[80vh] flex flex-col">
                    <label
                        htmlFor="location-modal"
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                    >
                        ✕
                    </label>
                    <h3 className="font-bold text-lg mb-3">Delivery Location</h3>
                    <div ref={mapRef} className="flex-grow rounded border" />
                    <div className="modal-action">
                        <a
                            href={`https://www.google.com/maps?q=${lat},${lng}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary"
                        >
                            <FaLocationArrow /> Open in Google Maps
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LocationModal;